import { c as _c } from "react/compiler-runtime";
import { useProfile } from "../../../global-account/react/index.js";
import { useConnectedWalletDisplay } from "./useConnectedWalletDisplay.js";
/**
 * Hook that provides connected user's address, profile, and cleaned display name
 * Combines logic for getting connected address from either global account or thirdweb wallets
 */
export function useConnectedUserProfile(selectedCryptoPaymentMethod) {
  const $ = _c(6);
  const {
    walletAddress
  } = useConnectedWalletDisplay(selectedCryptoPaymentMethod);
  let t0;
  if ($[0] !== walletAddress) {
    t0 = {
      address: walletAddress
    };
    $[0] = walletAddress;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const connectedProfile = useProfile(t0);
  const t1 = connectedProfile.data?.name;
  let t2;
  if ($[2] !== connectedProfile || $[3] !== t1 || $[4] !== walletAddress) {
    t2 = {
      address: walletAddress,
      profile: connectedProfile,
      name: t1,
      isLoading: connectedProfile.isLoading,
      isError: connectedProfile.isError,
      error: connectedProfile.error
    };
    $[2] = connectedProfile;
    $[3] = t1;
    $[4] = walletAddress;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}